'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.itemViewAction = itemViewAction;
exports.playVideo = playVideo;
exports.pauseVideo = pauseVideo;
var ITEM_VIEW_ACTION = exports.ITEM_VIEW_ACTION = 'ITEM_VIEW_ACTION';
var PLAY_VIDEO = exports.PLAY_VIDEO = 'PLAY_VIDEO';
var PAUSE_VIDEO = exports.PAUSE_VIDEO = 'PAUSE_VIDEO';

function itemViewAction() {
  return {
    type: ITEM_VIEW_ACTION
  };
}

function playVideo(idx) {
  return {
    idx: idx,
    type: PLAY_VIDEO
  };
}

function pauseVideo() {
  return {
    type: PAUSE_VIDEO
  };
}